import React, { useState } from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import HeaderSidebar from './HeaderSidebar';
import { motion } from 'framer-motion';

const MotionBox = motion(Box);

const Layout = ({ children }) => {
  const [isNavbar, setIsNavbar] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const paddingLeftValue = isMobile
    ? 0
    : sidebarOpen
    ? 280
    : isNavbar
    ? 0
    : 80;

  const paddingTopValue = isMobile ? 0 : isNavbar ? 100 : 0;

  return (
    <Box sx={{ display: 'flex', minHeight: '116vh', overflow: 'hidden' }}>
      <HeaderSidebar
        knowIsNavbar={setIsNavbar}
        knowSidebarOpen={setSidebarOpen}
      />

      {/* MAIN CONTENT WITH MOTION */}
      <MotionBox
        animate={{
          paddingLeft: paddingLeftValue,
          paddingTop: paddingTopValue,
        }}
        transition={{
          duration: 0.45,
          ease: [0.4, 0, 0.2, 1], // material design curve
        }}
        sx={{
          flexGrow: 1,
          minHeight: '116vh',
          backgroundColor: '#f1f5f91e',
          overflow: 'hidden',
        }}
      >
        {/* CHILDREN TRANSITION */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.35, ease: 'easeOut' }}
        >
          {children}
        </motion.div>
      </MotionBox>
    </Box>
  );
};

export default Layout;
